<div class="editor-wrapper">
  @if (saving$ | async) {
    <div>
      <app-loading [size]="'3x'"></app-loading>
    </div>
  } @else {
    <app-dynamic-form
      [formProperties]="formProperties"
      [formGroup]="formGroup"
      [fieldFilterString]="searchString"
    ></app-dynamic-form>
  }
</div>
